import { SecurityGroups } from '@morningstar/shared/auth';

export class SecurityGroupAuthorization {
  static isUserAuthorized(userSecurityGroup: number, requiredAuthorizationLevel: number): boolean {

    if ((userSecurityGroup === SecurityGroups.LedgerOnly ||
        userSecurityGroup === SecurityGroups.DAGG ||
        userSecurityGroup === SecurityGroups.LedgerPlusDAAG) &&
        requiredAuthorizationLevel === SecurityGroups.Reports) {
      return false;
    }

    return userSecurityGroup <= requiredAuthorizationLevel;
  }
}
